import React from 'react'
import { addRedirectQueryToRoute } from '@chegg-wt/core/utils/routes'
import { Dispatch } from 'redux'
import { origins } from '@chegg-wt/core/state/instrumentation/rio/clickstreamInteractions'
import { connect } from 'react-redux'
import { userClick } from '@chegg-wt/core/state/instrumentation/actions'
import { authModalExpFlagSelector } from '@chegg-wt/core/state/createCitation/selectors'
import { ONE_AUTH_MODAL } from '@chegg-wt/core/state/modals/constants'
import { openModal } from '@chegg-wt/core/state/modals/actions'
import { AppState } from '@chegg-wt/core/state'
import { useRoutesContext } from '../RoutesContext'

import AppLink from '../AppLink'
import { AuthModalOrigin } from '../Modals/AuthModal/types'
import * as Styled from './styled'

interface CitationsUpsellWrapperProps {
  onUserClickCreateAccountCTA: (authModalExpFlag: boolean) => void
  onUserClickSignInCTA: (authModalExpFlag: boolean) => void
  children: React.ReactNode
  authModalExpFlag: boolean
}

const CitationsUpsellWrapper: React.FC<CitationsUpsellWrapperProps> = ({
  onUserClickCreateAccountCTA,
  onUserClickSignInCTA,
  children,
  authModalExpFlag,
}) => {
  const { toSignup, toLogin } = useRoutesContext()
  const currentLocation = window.location.href
  const upgradeSignUpRoute = addRedirectQueryToRoute(toSignup(), currentLocation)
  const upgradeSignInRoute = addRedirectQueryToRoute(toLogin(), currentLocation)

  return (
    <Styled.Container>
      <Styled.CenterContent>
        <Styled.TextBox>
          {authModalExpFlag ? (
            <Styled.AuthAnchor
              onClick={() => onUserClickCreateAccountCTA(authModalExpFlag)}
            >
              Create account
            </Styled.AuthAnchor>
          ) : (
            <AppLink route={upgradeSignUpRoute}>
              <Styled.AuthLink
                onClick={() => onUserClickCreateAccountCTA(authModalExpFlag)}
              >
                Create account
              </Styled.AuthLink>
            </AppLink>
          )}
          &nbsp;or&nbsp;
          {authModalExpFlag ? (
            <Styled.AuthAnchor onClick={() => onUserClickSignInCTA(authModalExpFlag)}>
              sign in
            </Styled.AuthAnchor>
          ) : (
            <AppLink route={upgradeSignInRoute}>
              <Styled.AuthLink onClick={() => onUserClickSignInCTA(authModalExpFlag)}>
                sign in
              </Styled.AuthLink>
            </AppLink>
          )}
          &nbsp;to start a new citation list
        </Styled.TextBox>
      </Styled.CenterContent>
      <Styled.Children aria-hidden="true">{children}</Styled.Children>
    </Styled.Container>
  )
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onUserClickCreateAccountCTA: (authModalExpFlag: boolean) => {
    dispatch(userClick({ origin: origins.citationsDashCreateAccountCitationWidgetCTA }))
    if (authModalExpFlag) {
      dispatch(
        openModal({
          name: ONE_AUTH_MODAL,
          data: {
            defaultFlow: 'signup',
            origin: AuthModalOrigin.DASHBOARD_PAGE_WIDGET,
          },
        })
      )
    }
  },
  onUserClickSignInCTA: (authModalExpFlag: boolean) => {
    dispatch(userClick({ origin: origins.citationsDashSignInCitationWidgetCTA }))
    if (authModalExpFlag) {
      dispatch(
        openModal({
          name: ONE_AUTH_MODAL,
          data: {
            defaultFlow: 'signin',
            origin: AuthModalOrigin.DASHBOARD_PAGE_WIDGET,
          },
        })
      )
    }
  },
})

const mapStateToProps = (state: AppState) => ({
  authModalExpFlag: authModalExpFlagSelector(state),
})

export default connect(mapStateToProps, mapDispatchToProps)(CitationsUpsellWrapper)
